import { createSelector } from "reselect";

const selectUser = (state) => state.user;

export const selectCurrentUser = createSelector(
  [selectUser],
  (user) => user.currentUser
);

export const selectSessionExpired = createSelector(
  [selectUser],
  (user) => user.sessionExpired
);

export const selectSessionExpiredReason = createSelector(
  [selectUser],
  (user) => user.sessionExpiredReason
);
